import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericUploadFileV2 from '../../../components/GenericUploadFile/GenericUploadFileV2';
import { EXTENSIONES_VALIDAS_DE_ARCHIVOS } from '../../../constants/hardCodedConstants';

// Bloque reutilizable "Rúbrica de evaluación": muestra el/los archivo(s) ya
// cargado(s) como enlaces descargables + el control de subida.
// Se usa en ProgramarClaseModelo.jsx y ResultadoClaseModelo.jsx para compartir
// la misma estructura y, sobre todo, las mismas extensiones válidas.
// Extraído de ProgramarClaseModelo.jsx (antes RubricaContainer/RubricaContent/
// RubricaArchivo locales).
//
// IMPORTANTE (xlsx): las extensiones por defecto incluyen "xlsx"
// (EXTENSIONES_VALIDAS_DE_ARCHIVOS + "xlsx") para que el input acepte y valide
// archivos de Excel, igual que en ProgramarClaseModelo.
const nombreDeArchivo = (archivo) =>
    archivo?.OriginalFileName ??
    archivo?.originalFileName ??
    archivo?.FileName ??
    archivo?.fileName ??
    '';

const RubricaUpload = ({
    id,
    archivos = [],
    onDescargar,
    uploadFileToS3,
    subiendoArchivoPublicState,
    setSubiendoArchivoPublicState,
    extensionesValidas = [...EXTENSIONES_VALIDAS_DE_ARCHIVOS, 'xlsx'],
    toolTipText,
    isIcon = false,
    textButton,
    showToastSuccess = true,
    resetInitialFile = false,
    layout = 'row',
}) => {
    const esColumna = layout === 'column';
    return (
        <RubricaContent
            style={{
                flexDirection: esColumna ? 'column' : 'row',
                alignItems: esColumna ? 'flex-start' : 'center',
            }}
        >
            {archivos.filter(Boolean).map((item, index) => {
                const archivo = item?.archivo ?? item;
                const etiqueta = item?.etiqueta;
                return (
                    <div key={index}>
                        {etiqueta && <label>{etiqueta}</label>}
                        <RubricaArchivo
                            type="button"
                            title={nombreDeArchivo(archivo)}
                            onClick={() => onDescargar && onDescargar(archivo)}
                        >
                            <FontAwesomeIcon icon="paperclip" className="mr-2" />
                            <u>{nombreDeArchivo(archivo)}</u>
                        </RubricaArchivo>
                    </div>
                );
            })}

            <GenericUploadFileV2
                uploadFileToS3={uploadFileToS3}
                id={id}
                isIcon={isIcon}
                textButton={textButton}
                toolTipText={toolTipText}
                extensionesValidas={extensionesValidas}
                resetInitialFile={resetInitialFile}
                showToastSuccess={showToastSuccess}
                subiendoArchivoPublicState={subiendoArchivoPublicState}
                setSubiendoArchivoPublicState={setSubiendoArchivoPublicState}
            />
        </RubricaContent>
    );
};

export default RubricaUpload;

export const RubricaContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
`;

const RubricaContent = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

const RubricaArchivo = styled.button`
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    max-width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
